
import FooterBackground from "./FooterBackground";
import FooterCopyright from "./FooterCopyright";
import FooterInfoSocial from "./FooterInfoSocial";
import FooterLoanAmounts from "./FooterLoanAmounts";
import FooterLogo from "./FooterLogo";
import FooterProducts from "./FooterProducts";
import FooterSecurityBanner from "./FooterSecurityBanner";
import { useIsMobile } from "@/hooks/use-mobile";

const Footer = () => {
  const isMobile = useIsMobile();
  
  return (
    <footer className="bg-gradient-to-b from-blue-800 to-blue-900 text-white relative overflow-hidden w-full">
      {/* Animated background elements */}
      <FooterBackground />
      
      {/* SSL Security Banner */}
      <FooterSecurityBanner />
      
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-6">
          {/* Column 1: Logo and brief description */}
          <div className="lg:col-span-3">
            <FooterLogo />
          </div>
          
          {/* Column 2: Hae lainaa summalle */}
          <div className="lg:col-span-3">
            <FooterLoanAmounts />
          </div>
          
          {/* Column 3: Tuotteet */}
          <div className="lg:col-span-3">
            <FooterProducts />
          </div>
          
          {/* Column 4: Info & Seuraa meitä */}
          <div className="lg:col-span-3">
            <FooterInfoSocial />
          </div>
        </div>
        
        <FooterCopyright />
      </div>
    </footer>
  );
};

export default Footer;
